import { createReducer, createSelector } from '@reduxjs/toolkit'
import { filter, find, map, orderBy } from 'lodash'

import userTypes from '../user/types'
import calendarTypes from './types'

export { default as actions } from './actions'

export const selectVisibleCalendars = createSelector(
  (state) => state.linkedCalendars,
  (calendars) => filter(calendars, 'visible'),
)

const hydrateState = (state, config = {}) => {
  const formattedCalendars = map(config.ReadCalendars, (record) => {
    const newCalendar = {
      id: record.Id,
      label: record.Label,
    }
    const currentCalendarState = find(state, { id: record.Id })
    newCalendar.visible = !currentCalendarState || currentCalendarState.visible
    return newCalendar
  })
  return orderBy(formattedCalendars, 'id', 'asc')
}

export default createReducer([], {
  [userTypes.FETCH_USER_SUCCESS]: (state, action) => {
    return hydrateState(state, action.payload.CalendarConfig)
  },
  [calendarTypes.SHOW_LINKED_CALENDAR]: (state, action) => {
    find(state, { id: action.payload }).visible = true
  },
  [calendarTypes.HIDE_LINKED_CALENDAR]: (state, action) => {
    find(state, { id: action.payload }).visible = false
  },
})
